"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareQueryPropsObject = exports.QueryRoute = void 0;
var React = require("react");
var react_router_1 = require("react-router");
var matches_query_1 = require("./matches-query");
/**
 * The public API for matching a search/query and rendering.
 */
var QueryRoute = /** @class */ (function (_super) {
    __extends(QueryRoute, _super);
    function QueryRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            matchesQuery: _this.computeMatch(_this.props)
        };
        return _this;
    }
    QueryRoute.prototype.computeMatch = function (details) {
        var queryMatch = details.queryMatch, query = details.query, history = details.history;
        var search = this.props.search || history.location.search;
        // If QuerySwitch has already processed this as a match, no need for duplication of effort.
        if (queryMatch) {
            return true;
        }
        var doesMatch = query ? (0, matches_query_1.matchesQuery)(search, query) : false;
        return doesMatch;
    };
    QueryRoute.prototype.UNSAFE_componentWillMount = function () {
        var _this = this;
        var history = this.props.history;
        this.unlisten = history.listen(function () {
            var doesMatchQuery = _this.computeMatch(_this.props);
            if (_this.state.matchesQuery !== doesMatchQuery) {
                _this.setState({ matchesQuery: doesMatchQuery });
            }
        });
    };
    QueryRoute.prototype.componentWillUnmount = function () {
        this.unlisten();
    };
    QueryRoute.prototype.render = function () {
        var children = this.props.children;
        if (!this.state.matchesQuery) {
            return null;
        }
        return children;
    };
    QueryRoute = __decorate([
        react_router_1.withRouter
    ], QueryRoute);
    return QueryRoute;
}(React.Component));
exports.QueryRoute = QueryRoute;
// Utility Method
var compareQueryPropsObject = function (objA, objB) {
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    // Compare keys
    if (keysA.length !== keysB.length) {
        return false;
    }
    var keysEqual = keysA.every(function (key) { return keysB.includes(key); });
    if (!keysEqual) {
        return false;
    }
    var valuesEqual = keysA.every(function (key) { return keysA[key] === keysB[key]; });
    return valuesEqual;
};
exports.compareQueryPropsObject = compareQueryPropsObject;
//# sourceMappingURL=query-route.js.map